<template>
  <div class="preloader" :class="{ visible: visible }" :style="{ transform: `scaleX(${percentage/100.0})` }"></div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
      ...mapState({
          visible: state => state.preloader.visible,
          percentage: state => state.preloader.percentage
      })
  }    
}
</script>
